function normalizeOptionalString(value, fallbackValue = null) {
  if (typeof value !== 'string') {
    return fallbackValue
  }

  const normalizedValue = value.trim()

  return normalizedValue || fallbackValue
}

function normalizeEnumValue(value, allowedValues, fallbackValue, aliases = {}) {
  const normalizedValue = normalizeOptionalString(value)
  const resolvedValue = normalizedValue ? aliases[normalizedValue] || normalizedValue : null

  return allowedValues.includes(resolvedValue) ? resolvedValue : fallbackValue
}

export const VIDEO_LAYOUT_IDS = Object.freeze({
  stageOverlay: 'stage-overlay',
  split: 'split',
  grid: 'grid',
})

export const RAIL_STATE_IDS = Object.freeze({
  collapsed: 'collapsed',
  docked: 'docked',
  stacked: 'stacked',
  filmstrip: 'filmstrip',
})

const VIDEO_LAYOUT_ALIASES = Object.freeze({
  classic: VIDEO_LAYOUT_IDS.stageOverlay,
  rail: VIDEO_LAYOUT_IDS.stageOverlay,
  pin: VIDEO_LAYOUT_IDS.stageOverlay,
  pinned: VIDEO_LAYOUT_IDS.stageOverlay,
  'classic-stage': VIDEO_LAYOUT_IDS.stageOverlay,
  'spotlight-right-rail': VIDEO_LAYOUT_IDS.stageOverlay,
  'split-dual': VIDEO_LAYOUT_IDS.split,
})

export function normalizeVideoLayoutId(
  layoutId,
  fallbackValue = VIDEO_LAYOUT_IDS.stageOverlay,
) {
  return normalizeEnumValue(
    layoutId,
    Object.values(VIDEO_LAYOUT_IDS),
    fallbackValue,
    VIDEO_LAYOUT_ALIASES,
  )
}

export function normalizeRailStateId(
  railStateId,
  fallbackValue = RAIL_STATE_IDS.stacked,
) {
  return normalizeEnumValue(
    railStateId,
    Object.values(RAIL_STATE_IDS),
    fallbackValue,
  )
}
